<script>
    import Login from '../components/common/Login.svelte';
</script>

<div class="page-container">
    <div style="height: 10vh;"></div>
    <Login />
</div>